<template>
  <el-dialog
    :visible="detailDialogVisible"
    title="启动页配置详情"
    width="800px"
    @open="openDialog"
    @close="closeDialog"
     :before-close="handleClose"
  >
    <!-- <el-form
      :model="bannerDetail"
      ref="bannerForm"
      class="banner-form"
      :rules="rules"
      label-width="200px"
    >
      <el-form-item label="广告位置：" prop="type">
        <el-select :value="bannerDetail.type" @change="handleFormChange('type', $event)" placeholder="请选择">
          <el-option
            v-for="item in positionTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="flex_div">
        <el-form-item label="场景：" prop="type">
          <el-select
            :value="bannerDetail.type"
            @input="handleFormChange('type', $event)"
            placeholder="请选择"
          >
            <el-option
              v-for="item in bannerTypes"
              :key="item.type"
              :label="item.message"
              :value="Number(item.type)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" prop="bannertype">
          <el-select v-model="bannerDetail.bannerType" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="标题：" prop="title">
        <el-input
          :value="bannerDetail.title"
          @input="handleFormChange('title', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片：" prop="imageUrl">
        <upload
          :value="bannerDetail.imageUrl"
          @change="handleFormChange('imageUrl', $event)"
          :data="{
            language: this.bannerDetail.language,
            platform: this.bannerDetail.platform,
            category: 'banner',
          }"
        ></upload>
      </el-form-item>
      <el-form-item label="跳转地址：" prop="linkUrl">
        <el-input
          :value="bannerDetail.linkUrl"
          @input="handleFormChange('linkUrl', $event)"
        ></el-input>
      </el-form-item>
    </el-form> -->
    <el-form
        :model="startPageDetail"
        ref="startPageForm"
        class="banner-form"
        :rules="rules"
        label-width="180px"
      >
       
        <div class="flex_div">
        <el-form-item label="配置类型：" prop="confType">
          <el-select v-model="startPageDetail.confType" placeholder="请选择">
            <el-option
              v-for="item in confTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转类型：" prop="type">
          <el-select v-model="startPageDetail.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        </div>
        <div class="flex_div">
        <!-- <el-form-item label="配置类型：" prop="confType">
          <el-select v-model="startPageDetail.confType" placeholder="请选择">
            <el-option
              v-for="item in confTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
         <el-form-item label="平台区分：" prop="platform">
          <el-select v-model="startPageDetail.platform"  placeholder="请选择">
            <el-option
              v-for="item in platformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
       
        </div>
       
        <div class="flex_div btn">
          <el-form-item label="是否登录：" prop="login">
            <el-switch
              v-model="startPageDetail.login"
              active-color="#13ce66"
              >
            </el-switch>
          </el-form-item>
          <el-form-item label="是否开启：" prop="confOpen">
            <el-switch
              v-model="startPageDetail.confOpen"
              active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>
        </div>
         <el-form-item label="显示名称：" prop="displayName">
          <el-input v-model="startPageDetail.displayName"></el-input>
        </el-form-item>
        <el-form-item label="icon图标" prop="icon">
          <upload v-model="confObj.icon" :data="query"></upload>
        </el-form-item>
        <div class="flex_div">
          <el-form-item label="地址选择：" prop="urlType" class="url">
            <el-select v-model="urlType" 
            @change="changeUrl($event)"
            placeholder="请选择地址" 
            class="url_select">
              <el-option
                v-for="item in urloptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          <el-input v-model="urlDetail" style="width: 358px;"></el-input>
        </el-form-item>
        </div>
        
        <div class="flex_div">
           <el-form-item label="最低版本：" prop="verL">
          <el-input v-model="startPageDetail.verL"></el-input>
        </el-form-item>
        <el-form-item label="最高版本：" prop="verH">
          <el-input v-model="startPageDetail.ver"></el-input>
        </el-form-item>
        </div>
       
      </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('bannerForm')"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Upload from "components/upload";

export default {
  name: "BannerDetail",
  props: ["value"],
  data() {
    return {
      rules: {
        title: [{ required: true, message: "标题不能为空！" }],
        imageUrl: [{ required: true, message: "图片不能为空！" }],
      },
      options: [
        {
          value: "image",
          label: "图片",
        },
        {
          value: "custom",
          label: "自定义",
        },
      ],
    };
  },
  components: {
    Upload,
  },
  
  computed: {
    ...mapState("addAdvertisePageSetting", [
      "detailDialogVisible",
      "positionTypeList",
      "platformTypeList",
      "languageList",
      "bannerTypes",
    ]),
    ...mapGetters("addAdvertisePageSetting", ["bannerDetail", "bannerList"]),
  },
  methods: {
    ...mapActions("addAdvertisePageSetting", ["detail", "update", "list"]),
    ...mapMutations("addAdvertisePageSetting", [
      "toggleDetailDialogVisible",
      "setBannerDetail",
    ]),
    openDialog() {
      this.detail(this.value);
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
    },
    handleFormChange(type, value) {
      this.setBannerDetail({
        ...this.bannerDetail,
        [type]: value,
      });
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.update(this.bannerDetail).then(() => {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.toggleDetailDialogVisible(false);
            this.$emit("refresh");
          });
        }
      });
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
  },
};
</script>

<style lang="less" scoped>
.banner-form {
  margin-right: 100px;
}
.flex_div {
  display: flex;
}
</style>
